import SocialButton from 'src/components/consumptionPage/ConsumptionMetaData/SocialButtons/SocialButton';
import { useAppStore } from 'src/hooks/useAppStore';
import {
  CommerceIconsSet,
  IconsSetType
} from 'src/utils/constants/IconsConstants';

interface ShopBtnProps {
  disable: boolean;
  handleCommerceLayout?: () => void;
}

const ShopBtn: React.FC<ShopBtnProps> = ({
  disable = false,
  handleCommerceLayout
}) => {
  const { translations } = useAppStore();
  const {
    plex: {
      ContextualCommerce_BannerCTA = '',
      ContextualCommerce_Shop = ''
    } = {}
  } = translations || {};

  return (
    <div title={ContextualCommerce_BannerCTA}>
      <SocialButton
        icon={CommerceIconsSet.SHOP}
        type={IconsSetType.COMMERCE}
        name={ContextualCommerce_Shop}
        disable={disable}
        action={handleCommerceLayout}
        id="shop-btn"
      />
    </div>
  );
};

export default ShopBtn;
